import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { ContainedButton } from './StyledButtons';
import Colors from '../../constants/Colors';
import { ErrorOutline, InfoOutlined } from '@mui/icons-material';

export const BANNER_VARIANTS = {
    INFO: 'info',
    WARNING: 'warning',
    IMPORTANT: 'important',
}

const StyledBanner = ({ 
    onFix,
    title,
    variant = BANNER_VARIANTS.INFO,
    description
}) => {

  const getBorderColor = () => {
    switch(variant) {
        case BANNER_VARIANTS.WARNING:
            return Colors.warningBackground
        case BANNER_VARIANTS.INFO:
          return Colors.infoLightBackground
        case BANNER_VARIANTS.IMPORTANT:
          return Colors.primaryColor;
        default:
            return "#fff";
        
    }
  }

  const getBackgroundColor = () => {
    switch(variant) {
        case BANNER_VARIANTS.WARNING:
            return Colors.warningBannerBackground
        case BANNER_VARIANTS.INFO:
          return Colors.infoLightBannerBackground
        case BANNER_VARIANTS.IMPORTANT:
          return Colors.importantLightBannerBackground;
        default:
            return "#fff";
        
    }
  }

  const getIcon = () => {
    switch(variant) {
        case BANNER_VARIANTS.WARNING:
            return <WarningAmberIcon sx={{ color: '#fff' }} />
        case BANNER_VARIANTS.IMPORTANT:
          return <ErrorOutline sx={{ color: '#000' }} />
        case BANNER_VARIANTS.INFO:
        default:
            return <InfoOutlined />
        
    }
  }

  return (
<Paper
  elevation={1}
  variant="outlined"
  sx={{
    width: '100%',
    backgroundColor: getBackgroundColor(),
    border: '2px solid',
    borderColor: getBorderColor()
  }}
>
  <Box
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    gap={2}
    sx={{ padding: '18px' }}
  >
    <Box
      display="flex"
      alignItems="center"
      gap={2}
      sx={{
        flex: 1,
        minWidth: 0
      }}
    >
      {getIcon()}

      <Box sx={{ minWidth: 0 }}>
        <h4 style={{ fontSize: '20px', padding: 0, marginTop: 0, marginBottom: 0 }}>
          {title}
        </h4>
        <p style={{ marginTop: 0, paddingTop: 0, marginBottom: 0, paddingBottom: 0 }}>
          {description}
        </p>
      </Box>
    </Box>

    {onFix && (
      <Box sx={{ flexShrink: 0 }}>
        <ContainedButton onClick={onFix}>Fix Now</ContainedButton>
      </Box>
    )}
  </Box>
</Paper>
  );
}

export default StyledBanner;